import React from "react";
import { Link } from "react-router-dom";
import { NAV_CATEGORIES } from "../lib/categories";
import { Youtube, Instagram, Mail, MapPin } from "lucide-react";
import { BRAND, SOCIAL, MAILTO, EMAIL_LABEL } from "../lib/brand";

const POLICIES = [
  { to: "/page/editorial-policy", label: "Editorial Policy" },
  { to: "/page/privacy-policy", label: "Privacy Policy" },
  { to: "/page/terms", label: "Terms & Conditions" },
  { to: "/page/disclaimer", label: "Disclaimer" },
  { to: "/page/corrections-policy", label: "Corrections Policy" },
  { to: "/page/fact-check-policy", label: "Fact Check Policy" },
];

export default function Footer() {
  return (
    <footer className="bg-r24-black text-gray-300 mt-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/brand/logo.jpg" alt="Rapid24News" className="h-12 w-12 rounded-full object-cover ring-2 ring-r24-red" />
            <div className="font-head font-bold text-xl text-white">RAPID<span className="text-r24-red">24</span>NEWS</div>
          </div>
          <p className="text-sm text-gray-400 uc tracking-widest font-semibold mb-4">Fast • Trusted • Fearless</p>
          <p className="text-sm leading-relaxed text-gray-400 mb-4">Lucknow's daily news desk, Uttar Pradesh news network, national platform & investigative digital media portal.</p>
          <div className="space-y-2 text-sm">
            <a href={MAILTO} aria-label={EMAIL_LABEL} data-testid="footer-email" className="flex items-center gap-2 hover:text-r24-red"><Mail size={15} /> {BRAND.email}</a>
            <div className="flex items-center gap-2 text-gray-400"><MapPin size={15} /> {BRAND.location}</div>
          </div>
          <div className="flex gap-3 mt-5">
            <a href={SOCIAL.youtube.url} target="_blank" rel="noopener noreferrer" aria-label={SOCIAL.youtube.label} data-testid="footer-youtube" className="bg-white/10 hover:bg-r24-red w-9 h-9 flex items-center justify-center transition-colors"><Youtube size={18} /></a>
            <a href={SOCIAL.instagram.url} target="_blank" rel="noopener noreferrer" aria-label={SOCIAL.instagram.label} data-testid="footer-instagram" className="bg-white/10 hover:bg-r24-red w-9 h-9 flex items-center justify-center transition-colors"><Instagram size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-head font-bold text-white uc text-sm mb-4">Sections</h4>
          <ul className="space-y-2 text-sm">
            {NAV_CATEGORIES.slice(0, 8).map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className="hover:text-r24-red">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-white uc text-sm mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-r24-red">About Us</Link></li>
            <li><Link to="/page/contact" className="hover:text-r24-red">Contact Us</Link></li>
            <li><Link to="/page/advertise" className="hover:text-r24-red">Advertise With Us</Link></li>
            <li><Link to="/page/careers" className="hover:text-r24-red">Careers</Link></li>
            <li><Link to="/submit-tip" className="hover:text-r24-red">Submit News Tip</Link></li>
            <li><Link to="/archive" className="hover:text-r24-red">News Archive</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-white uc text-sm mb-4">Policies</h4>
          <ul className="space-y-2 text-sm">
            {POLICIES.map((p) => (
              <li key={p.to}><Link to={p.to} className="hover:text-r24-red">{p.label}</Link></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} Rapid24News. All rights reserved.</span>
          <span className="flex items-center gap-3">
            <span>Shivam Dubey — <span className="text-gray-300">Editor-in-Chief &amp; Founder</span></span>
            <Link to="/admin/login" data-testid="footer-editor-login" className="text-gray-600 hover:text-r24-red">Editor Login</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
